const API_BASE = process.env.REACT_APP_API_BASE_URL || '/api';
const BASE = API_BASE.replace(/\/$/, '');

const req = async (method, path, body) => {
  const res = await fetch(`${BASE}${path}`, {
    method,
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: body ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: res.statusText }));
    throw new Error(err.error || 'Request failed');
  }
  return res.json();
};

export const api = {
  // Auth
  getSession: () => req('GET', '/auth/me'),
  login: (data) => req('POST', '/auth/login', data),
  logout: () => req('POST', '/auth/logout'),
  // Opens the SSE stream that reports instant force-logout events for the
  // current session (e.g. someone else just signed in as this user).
  openAuthEvents: () => new EventSource(`${BASE}/auth/events`, { withCredentials: true }),

  // Departments
  getDepartments: () => req('GET', '/departments'),
  createDepartment: (data) => req('POST', '/departments', data),
  updateDepartment: (id, data) => req('PUT', `/departments/${id}`, data),
  deleteDepartment: (id) => req('DELETE', `/departments/${id}`),

  // Employees
  getEmployees: (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return req('GET', `/employees${qs ? '?' + qs : ''}`);
  },
  createEmployee: (data) => req('POST', '/employees', data),
  updateEmployee: (id, data) => req('PUT', `/employees/${id}`, data),
  deleteEmployee: (id) => req('DELETE', `/employees/${id}`),

  // Items
  getItems: (active = true) => req('GET', `/items?active=${active}`),
  createItem: (data) => req('POST', '/items', data),
  updateItem: (id, data) => req('PUT', `/items/${id}`, data),
  deleteItem: (id) => req('DELETE', `/items/${id}`),

  // Orders
  getOrders: (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return req('GET', `/orders${qs ? '?' + qs : ''}`);
  },
  getOrder: (id) => req('GET', `/orders/${id}`),
  createOrder: (data) => req('POST', '/orders', data),
  deleteOrder: (id) => req('DELETE', `/orders/${id}`),

  // Expenses
  getExpenses: (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return req('GET', `/expenses${qs ? '?' + qs : ''}`);
  },
  createExpense: (data) => req('POST', '/expenses', data),
  deleteExpense: (id) => req('DELETE', `/expenses/${id}`),

  // Staff
  getStaff: (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return req('GET', `/staff${qs ? '?' + qs : ''}`);
  },
  createStaff: (data) => req('POST', '/staff', data),

  // Staff payments
  getStaffPayments: (staffId) => req('GET', `/staff/${staffId}/payments`),
  createStaffPayment: (staffId, data) => req('POST', `/staff/${staffId}/payments`, data),
  deleteStaffPayment: (id) => req('DELETE', `/staff/payments/${id}`),

  // Reports
  getDashboard: () => req('GET', '/reports/dashboard'),
  getMonthlySummary: (month) => req('GET', `/reports/monthly-summary?month=${month}`),
  getItemConsumption: (month) => req('GET', `/reports/item-consumption?month=${month}`),
  getDailyTotals: (month) => req('GET', `/reports/daily-totals?month=${month}`),
  getEmployeeOrders: (employeeId, month) => req('GET', `/reports/employee-orders?employee_id=${employeeId}&month=${month}`),
  searchEmployees: (query) => req('GET', `/reports/employee-search?q=${encodeURIComponent(query)}`),
  getEmployeeProfile: (id) => req('GET', `/reports/employee-profile/${id}`),
  getEmployeeHistory: (id, params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return req('GET', `/reports/employee-history/${id}${qs ? '?' + qs : ''}`);
  },
};
